import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { BsInboxFill } from 'react-icons/bs';

export default function NoData({ 
  loading = false, 
  title = "No Data Found", 
  message = "There are currently no records to display. Try adjusting your search filters or add a new entry.",
  loadingTitle = "Loading Records...",
  loadingMessage = "Please wait while we fetch the latest workspace data."
}) {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '260px',
          width: '100%',
          bgcolor: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e2e8f0',
          p: 4,
          my: 2,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
          textAlign: 'center'
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
          <CircularProgress size={44} thickness={4} sx={{ color: '#3b82f6' }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5, fontSize: '1.1rem' }}>
          {loadingTitle}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', maxWidth: 420, lineHeight: 1.5, fontSize: '0.875rem' }}>
          {loadingMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '260px',
        width: '100%',
        bgcolor: '#ffffff',
        borderRadius: '16px',
        border: '1px dashed #cbd5e1',
        p: 4,
        my: 2,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
        textAlign: 'center'
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: '#f8fafc',
          border: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#64748b',
          mb: 2,
          boxShadow: 'inset 0 2px 4px 0 rgba(0,0,0,0.05)'
        }}
      >
        <BsInboxFill size={28} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5, fontSize: '1.1rem' }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: '#64748b', maxWidth: 420, lineHeight: 1.5, fontSize: '0.875rem' }}>
        {message}
      </Typography>
    </Box>
  );
}
